import * as yup from "yup";

const workExperienceSchema = yup.object({
    employerName: yup
        .string()
        .trim()
        .required("Employer name is required."),

    endDate: yup
        .string()
        .nullable()
        .required("End date is required.")
});

export default workExperienceSchema;
